import React from 'react';
import { Project } from '../data/site';
import { ProjectScene } from './ProjectScene';
import { IconArrowUpRight } from './Icons';

type Props = {
  project: Project;
  flip?: boolean;
};

export const Showcase: React.FC<Props> = ({ project, flip }) => (
  <article className={`showcase ${flip ? 'is-flip' : ''}`}>
    <div className="stage">
      <ProjectScene project={project} />
    </div>
    <div className="showcase-copy">
      <p className="eyebrow">
        {project.year} · {project.role}
      </p>
      <h2>{project.title}</h2>
      <p>{project.story}</p>
      <div className="meta-row">
        {project.tech.map((t) => (
          <span className="chip" key={t}>
            {t}
          </span>
        ))}
      </div>
      <a className="btn btn-ghost" href={project.href} target="_blank" rel="noopener noreferrer">
        {project.store === 'play'
          ? 'Play Store’da aç'
          : project.store === 'appstore'
            ? 'App Store’da aç'
            : 'Canlı site'}{' '}
        <IconArrowUpRight size={16} />
      </a>
    </div>
  </article>
);
